import { FlexCol } from '@/components/common/Flex';
import { BoxProps } from '@chakra-ui/react';
import { useMotionValueEvent, useScroll } from 'framer-motion';
import { FC, useState } from 'react';
import Footer from '../../compliance/Footer';
import ErrorBoundary from '../ErrorBoundary';
import Nav, { NavProps } from './Nav';
import PageSection from './PageSection';

export interface PageLayoutProps extends BoxProps, NavProps {
    showFooter?: boolean;
}

/** Nav border shown at point where nav becomes sticky */
export const NAV_MARGIN_Y = 6;
export const NAV_BORDER_THRESHOLD = NAV_MARGIN_Y * 4;

const PageLayout: FC<PageLayoutProps> = ({
    children,
    isAppLoading,
    showFooter = true,
    ...props
}) => {
    const [showNavBorder, setShowNavBorder] = useState(false);
    const { scrollY } = useScroll();
    useMotionValueEvent(scrollY, 'change', (latest) => {
        if (latest >= NAV_BORDER_THRESHOLD && !showNavBorder) {
            setShowNavBorder(true);
            return;
        }
        if (latest < NAV_BORDER_THRESHOLD && showNavBorder) {
            setShowNavBorder(false);
            return;
        }
    });

    return (
        <ErrorBoundary>
            <FlexCol w="full" minH="100vh" {...props}>
                <PageSection
                    position="sticky"
                    top={0}
                    my={NAV_MARGIN_Y}
                    bg="white"
                    zIndex={300}
                    transition="border-color 0.2s ease-in-out"
                    borderBottom="1px solid"
                    borderColor={showNavBorder ? 'gray.200' : 'white'}
                >
                    <Nav isAppLoading={isAppLoading} />
                </PageSection>
                <FlexCol w="full" grow={1}>
                    {children}
                </FlexCol>
                {showFooter && (
                    <PageSection grow={0} bg="gray.100">
                        {!isAppLoading && <Footer />}
                    </PageSection>
                )}
            </FlexCol>
        </ErrorBoundary>
    );
};

export default PageLayout;
